import { z } from "zod/v4";

import {
  ExperienceAnalysisQueryTemplateTypeList,
  OpenAiMessageSchema,
} from "../../../dtos/ai";

export const AiGetExperienceAnalysisRequestBodySchema = z.object({
  experienceId: z.string(),
  queryTemplate: z.enum(ExperienceAnalysisQueryTemplateTypeList),
  query: z.string().optional(),
  threadId: z.string(),
  assistantId: z.string(),
});

export type AiGetExperienceAnalysisRequestBodyType = z.infer<
  typeof AiGetExperienceAnalysisRequestBodySchema
>;

export const AiGetExperienceAnalysisResponseSchema = z.object({
  messages: OpenAiMessageSchema.array(),
});

export type AiGetExperienceAnalysisResponseBodyType = z.infer<
  typeof AiGetExperienceAnalysisResponseSchema
>;
